import React from "react";
import { Link } from "react-router-dom";
import { usePlans } from "../hooks/usePlans";
import { formatInrFromPaise } from "../utils/validation";
import LandingNav from "../components/landing/LandingNav";
import LandingFooter from "../components/landing/LandingFooter";
import "../styles/saas.css";

export default function PlanComparisonPage() {
  const { plans, loading } = usePlans();

  return (
    <div className="saas-landing-page">
      <LandingNav />

      <section className="saas-lp-section">
        <div className="saas-lp-inner">
          <div className="saas-lp-section__header">
            <p className="saas-lp-label">Compare</p>
            <h2>Find the right plan</h2>
            <p>Side-by-side pricing and limits for every Beentara plan.</p>
          </div>

          {loading ? (
            <p className="saas-lp-center-text">Loading…</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="saas-compare-table">
                <thead>
                  <tr>
                    <th>Feature</th>
                    {plans.map((p) => (
                      <th key={p.id || p.slug}>{p.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Monthly</td>
                    {plans.map((p) => (
                      <td key={p.id || p.slug}>{formatInrFromPaise(p.monthly_price_paise)}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Yearly</td>
                    {plans.map((p) => (
                      <td key={p.id || p.slug}>{formatInrFromPaise(p.yearly_price_paise)}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Users</td>
                    {plans.map((p) => (
                      <td key={p.id || p.slug}>{p.user_limit || "Unlimited"}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Free trial</td>
                    {plans.map((p) => (
                      <td key={p.id || p.slug}>
                        {p.trial_eligible ? `${p.trial_days} days` : "—"}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          <p className="saas-lp-center-text saas-lp-pricing__link" style={{ marginTop: "2rem" }}>
            <Link to="/signup?plan=starter">Start your free trial →</Link>
          </p>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
}
